import { useEffect, useState } from "react";
import GetNatureOfWorkService from "../../api/NatureOfWork/GetNatureOfWork/GetNatureOfWorkService";
import { header } from "../../context/constant";
import { INatureOfWork } from "../../components/Admin/NatureOfWork/NatureOfWorkType";
export const useGetNatureOfWork = () => {
    const [data, setData] = useState<INatureOfWork[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await GetNatureOfWorkService({ header });
            setData(result.data);
        } catch (error: any) {
            const err = await error;
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return { data, loading, error };
};